import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const TrafficHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Tráfico"
    text="Éste es el módulo de Gestión de Tráfico."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ TrafficUnit }) => ({
  cards: TrafficUnit.UnitHome.get('cards'),
  breadcrumbs: TrafficUnit.UnitHome.get('breadcrumbs'),
});

TrafficHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(TrafficHome);
